module.exports = __webpack_public_path__ + "static/media/emporio-armani-stronger-with-you-big.1e61810d.png";